<template>
  <v-app v-cloak id="inspire">
    <v-layout>
      <v-flex fill-height>
        <v-content class="main-content">
          <app-header />
          <loading-spinner v-if="$store.state.loading" :dialog="true" />
          <router-view v-else />
          <v-dialog v-model="sessionEndDlg" width="260" no-click-animation>
            <v-card>
              <v-card-text class="body-2">
                Your Secure Session Has Ended
                <span v-if="reauth" class="body-1">
                  <br />
                  Another user signed in from the same browser. Please login again.
                </span>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn v-if="!reauth" flat color="blue" to="/" @click="sessionEndDlg = false">Home Page</v-btn>
                <v-btn v-if="!reauth" flat color="blue" @click="relogin()">Login</v-btn>
                <v-btn v-if="reauth" flat color="blue" @click="sessionEndDlg = false">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-content>
      </v-flex>
    </v-layout>
    <app-footer />
  </v-app>
</template>

<script>
  import appFooter from 'components/app-footer';
  import appHeader from 'components/app-header';

  export default {
    components: {
      appFooter,
      appHeader
    },
    data() {
      return {
        sessionEndDlg: false
      };
    },
    computed: {
      reauth() {
        return this.$store.state.user.reauth;
      }
    },
    watch: {
      sessionEndDlg(after, before) {
        if (before === true && after === false && this.reauth) {
          this.relogin();
        }
      },
      alertDlg(after, before) {
        if (before && !after && this.alertCallback && typeof this.alertCallback === 'function') {
          this.alertCallback()
        }
      }
    },
    mounted: function () {
      this.$store.watch(this.$store.getters['user/isAuthenticated'], (after, before) => {
        if (before === true && after === false) {
          this.sessionEndDlg = true;
        }
      });
    },
    methods: {
      confirmed(val) {
        if (this.confirmCallback && typeof this.confirmCallback === 'function') {
          this.confirmCallback(val)
        }
        this.$emit(val ? 'yes' : 'no')
      },
      relogin() {
        this.$store.commit('user/setAfterLogin', { ...this.$route });
        this.$router.push({ name: 'Login' });
        this.sessionEndDlg = false;
      }
    }

  };
</script>

<style>

  @media print {
    html {
      zoom: 65%;
    }

    .layout {
      position: relative !important;
      max-width: 100% !important;
    }

    .provider-card {
      position: relative !important;
      max-width: 32% !important;
      page-break-inside: avoid !important;
    }

    nav, aside, .v-card__actions, button.v-btn, .v-select, #google_translate_element, .no-print {
      display: none !important;
    }

    .main-content {
      padding: 10px !important;
    }

    div.v-progress-linear__bar__determinate, div.v-progress-linear__bar {
      border: 1px solid;
    }

    div.v-progress-linear__bar__determinate {
      margin-top: 1px;
      height: 4px;
    }
  }

  .v-menu__content--fixed {
    position: fixed;
  }

  div.v-toolbar__extension {
    padding: 0;
  }

  .img-container {
    background-size: cover;
    overflow: hidden;
    width: 100%;
  }

  .main-content {
    background-color: rgb(59,65,83);
    padding-bottom: 0;
  }
  /*
  .v-dialog__content--active {
    z-index: 2001 !important;
  }

  .v-overlay.v-overlay--active {
    z-index: 1001 !important;
  }
  */
  .provider-icon-school-year {
    background-color: #2196f3;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
  }

  .provider-icon-summer {
    background-color: #6a1b9a;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  }

  .provider-icon-summer:hover, .provider-icon-school-year:hover {
    background-color: orange;
  }

  .provider-icon-summer span, .provider-icon-school-year span {
    color: white;
    font-weight: bold;
    font-size: 10px;
    display: inline-block;
    width: 100%;
    margin: auto;
    text-align: center;
  }

  span.v-chip__content span {
    line-height: 110%;
  }

  span.v-tooltip, .v-tooltip .v-chip, .v-tooltip .v-chip__content  {
    cursor: help;
  }

  .clickable * {
    cursor: pointer !important;
  }

  .crud-table table.v-datatable.v-table.theme--light > tbody > tr:hover {
    background-color: unset;
  }

  .crud-table .v-datatable__progress {
    display: none;
  }

  @media (min-width: 800px) {
    .custom-show {
      display: none;
    }
  }

  @media (max-width: 799px) {
    .custom-hide {
      display: none;
    }
  }

  .loadingOverlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    justify-content: center;
    display: flex;
    align-items: center;
    background-color: rgba(128, 128, 128, 0.3);
  }
</style>
